import StaticPage from '../_StaticPage'

export default function Support() {
  return (
    <StaticPage
      title="Support"
      description="Contact Tides Near Me support - email support@tidesnear.me for help with tide and current predictions."
    >
      <p>
        Need help with Tides Near Me? We're happy to assist. Email us and we'll get back to you as
        soon as we can.
      </p>
      <ul>
        <li>
          <b>Email:</b> <a href="mailto:support@tidesnear.me">support@tidesnear.me</a>
        </li>
      </ul>
    </StaticPage>
  )
}
